// API configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL 
  ? process.env.NODE_ENV === 'production'
    ? 'https://api.explanatum.co.uk'
    : process.env.REACT_APP_API_URL
  : 'http://localhost:5000';
